import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=75b7dfff&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"
import style0 from "./statistics.vue?vue&type=style&index=0&id=75b7dfff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b7dfff",
  null
  
)

export default component.exports